import { render, staticRenderFns } from "./c-list-empty.vue?vue&type=template&id=40816fe7&scoped=true"
import script from "./c-list-empty.vue?vue&type=script&lang=js"
export * from "./c-list-empty.vue?vue&type=script&lang=js"
import style0 from "./c-list-empty.vue?vue&type=style&index=0&id=40816fe7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40816fe7",
  null
  
)

export default component.exports